import { useQuery } from '@tanstack/react-query';
import { getAudits } from '../../../api/Terminal';
import type { QueryParamsInterface } from '../../../types/Shared';

export type AuditResourceType = 'project';

interface IAuditsHookProps {
  queryKey: string;
  resource_type: AuditResourceType;
  resource_id: number;
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

const useAudits = ({ queryKey, resource_type, resource_id, params, onSuccess, onError }: IAuditsHookProps) => {
  const serviceParams = { ...params, resource_type, resource_id };
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [queryKey, serviceParams],
    queryFn: () => getAudits({ params: serviceParams }),
    onSuccess,
    onError,
  });
};

export default useAudits;
